module.exports = __webpack_public_path__ + "Icono_Notificaciones_Blanco_512px.png";